import { useEffect } from "react";

import { useState } from "react";
import { PageLoading } from "../../../components/page_loading";
import Grid from "@mui/joy/Grid";
import Typography from "@mui/joy/Typography";
import FormControl from "@mui/joy/FormControl";
import FormLabel from "@mui/joy/FormLabel";
import Input from "@mui/joy/Input";
import FormHelperText from "@mui/joy/FormHelperText";

export const AlertsComponent = (props: {
  loading: boolean;
  deploymentId: string;
  alertsStackParamsJson: string | null;
  alertsStackStatus: string | null;
}) => {
  const { loading, alertsStackParamsJson, alertsStackStatus } = props;

  const [emailNotificationList, setEmailNotificationList] =
    useState<string>("");

  useEffect(() => {
    if (alertsStackParamsJson) {
      const params = JSON.parse(alertsStackParamsJson);
      setEmailNotificationList(params.EmailNotificationList || "");
    }
  }, [alertsStackParamsJson]);

  return (
    <>
      <PageLoading loading={loading} />
      <Grid container spacing={2} sx={{ flexGrow: 1 }}>
        <Grid xs={12}>
          <Typography level="body-sm" sx={{ py: 1 }}>
            CloudFormation stack status: {alertsStackStatus || "Not deployed"}
          </Typography>
        </Grid>
        <Grid xs={12} sm={6}>
          <FormControl>
            <FormLabel>Email Notification List</FormLabel>
            <Input
              disabled={true}
              value={emailNotificationList}
              onChange={(event) => {
                setEmailNotificationList(event.target.value);
              }}
            />
            <FormHelperText>
              The list of email addresses to notify when alerts are triggered.
            </FormHelperText>
          </FormControl>
        </Grid>
      </Grid>
    </>
  );
};
